import User from '../Entities/User.js';

function UserService (apiInstance)
{
	const api = apiInstance;

	this.resetPassword = (email) => {
		return api.request('POST', {email: email}, 'auth/reset-password', {}, {});
	}

	this.me = () => {
		return api.request('GET', {}, 'users/current', {}, {})
			.then(function (response) {
				const data = response.data.data.user;

				return {
					user: (!data) ? false : new User(response.data.data.user),
					server: response
				};
			});
	}
	
	this.list = () => {
		return api.request('GET', {}, 'users', {}, {})
			.then(function (response) {
				const data = response.data.data.users;
				return data.map(function (u) {
					return new User(u);
				});
			});
	}

	this.update = (user, key, value) => {
    let data = {};
    data[key] = value;
		return api.request('PUT', data, 'users/' + user.props.id, {}, {});
	}

	this.updateMany = (user, attributes) => {
		return api.request('PUT', attributes, 'users/' + user.props.id, {}, {});
	}

	this.delete = (user) => {
		return api.request('DELETE', {}, 'users/' + user.props.id, {}, {})
			.then(function (response) {
				const data = response.data.data;
				user.deleted_at = data.deleted_at;
				return user;
			})
	}

	this.undelete = (user) => {
		return api.request('PUT', { action: 'restore' }, 'users/' + user.props.id, {}, {})
			.then(function (response) {
				user.deleted_at = null;
				return user;
			})
	}

	return this;
}

export default UserService;


// WEBPACK FOOTER //
// ./src/Services/UserService.js